import {
  BrowserRouter,
  NavLink,
  Routes,
  Route,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import { useEffect, useState } from "react";

// import PublicRoute from './routes/PublicRoute'
// import PrivateRoute from './routes/PrivateRoute'
import { ActionType, Color, READY_EMPLOYER, Slug } from "./constants";
import NavBar from "./components/NavBar";
import Survey from "./pages/Survey";
import Results from "./pages/Results";
import AccountSettings from "./pages/AccountSettings";
import Login from "./pages/Login";
import PublicRoute from "./routes/PublicRoute";
import JobResultsPage from "./pages/JobResultsPage";
import GlobalHandler from "./components/Virtual/GlobalHandler";
import MatchesOnly from "./pages/MatchesOnly";
import PrivateRoute from "./routes/PrivateRoute";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Unsubscribe from "./pages/Unsubscribe";
import VerifySentPage from "./pages/VerifySentPage";
import VerifyEmailPage from "./pages/VerifyEmailPage";
import { useSelector } from "react-redux";
import EducationPage from "./pages/EducationPage";
import EduSignup from "./pages/EduSignup";
import EduSignupSuccess from "./pages/EduSignupSuccess";
import AdminPage from "./pages/AdminPage";
import GigSurvey from "./pages/GigSurvey";
import ReferralSignupRedirect from "./pages/ReferralSignupRedirect";
import { getDefaultSurveyFromCookie } from "./utils/utils";
import ApplyPage from "./pages/ApplyPage";
import AlreadyAppliedPage from "./pages/AlreadyAppliedPage";
import ApplicationSubmittedPage from "./pages/ApplicationSubmittedPage";
import InboxPage from "./pages/InboxPage";
import GlobalMessagesLoader from "./components/Virtual/GlobalMessagesLoader";
import MyApplicationsPage from "./pages/MyApplicationsPage";
import GoogleDriveDisclosure from "./pages/GoogleDriveDisclosure";
import NoReferralSplash from "./pages/NoReferralSplash";

function App() {
  const auth = useSelector((state) => state.auth);
  const loggedIn = auth.testing
    ? true
    : auth.accountData.loginToken !== null &&
      auth.accountData.contactInfo !== null;
  return (
    <div
      className="App"
      style={{
        // minWidth: '500px',
        backgroundColor: Color.bgLight,
        // minHeight: '100vh'
        // minHeight: 'max(100vh, 900px)'
      }}>
      <BrowserRouter>
        <GlobalHandler />
        {READY_EMPLOYER && <GlobalMessagesLoader />}
        <NavBar />
        <Routes>
          <Route
            path={Slug.home}
            element={
              <Navigate
                to={loggedIn ? Slug.jobResults : getDefaultSurveyFromCookie()}
              />
            }
          />
          <Route
            path={Slug.signupNoref + "/*"}
            element={<NoReferralSplash />}
          />
          <Route
            path={Slug.referralSignup + "/*"}
            element={<ReferralSignupRedirect />}
          />
          <Route
            path={Slug.emptySurvey}
            element={<Navigate to={Slug.surveyInitial} />}
          />
          <Route path={Slug.survey} element={<Survey />} />
          <Route path={Slug.surveyGig} element={<GigSurvey />} />
          <Route
            path={Slug.admin + "/*"}
            element={
              <PrivateRoute to={Slug.login}>
                <AdminPage />
              </PrivateRoute>
            }
          />
          <Route path={Slug.results} element={<Results />} />
          <Route
            path={Slug.login + "/*"}
            element={
              // <PublicRoute to={Slug.jobResults}>
              <Login />
              // </PublicRoute>
            }
          />
          <Route
            path={Slug.forgotPassword}
            element={
              <PublicRoute to={Slug.jobResults}>
                <ForgotPassword />
              </PublicRoute>
            }
          />
          <Route
            path={Slug.resetPassword + "/*"}
            element={
              <PublicRoute to={Slug.jobResults}>
                <ResetPassword />
              </PublicRoute>
            }
          />
          <Route path={Slug.unsubscribe + "/*"} element={<Unsubscribe />} />
          <Route
            path={Slug.settings}
            element={
              <PrivateRoute to={Slug.login}>
                <AccountSettings />
              </PrivateRoute>
            }
          />
          <Route
            path={Slug.apply + "/*"}
            element={
              <PrivateRoute to={Slug.login}>
                <ApplyPage />
              </PrivateRoute>
            }
          />
          <Route
            path={Slug.alreadyApplied + "/*"}
            element={
              <PrivateRoute to={Slug.login}>
                <AlreadyAppliedPage />
              </PrivateRoute>
            }
          />
          <Route
            path={Slug.applySuccess + "/*"}
            element={
              <PrivateRoute to={Slug.login}>
                <ApplicationSubmittedPage />
              </PrivateRoute>
            }
          />
          <Route
            path={Slug.jobResults + "/*"}
            element={
              <PrivateRoute to={Slug.login}>
                <JobResultsPage />
              </PrivateRoute>
            }
          />
          <Route
            path={Slug.matchesOnly + "/*"}
            element={
              <PrivateRoute to={Slug.login}>
                <MatchesOnly />
              </PrivateRoute>
            }
          />
          <Route
            path={Slug.sentVerificationEmail}
            element={
              <PrivateRoute to={Slug.login}>
                <VerifySentPage />
              </PrivateRoute>
            }
          />
          <Route path={Slug.verifyEmail + "/*"} element={<VerifyEmailPage />} />
          <Route path={Slug.education + "/*"} element={<EducationPage />} />
          <Route path={Slug.signUp + "/*"} element={<EduSignup />} />
          <Route
            path={Slug.signUpSuccess + "/*"}
            element={<EduSignupSuccess />}
          />
          <Route
            path={Slug.inbox + "/*"}
            element={
              <PrivateRoute to={Slug.login}>
                <InboxPage />
              </PrivateRoute>
            }
          />
          <Route
            path={Slug.myApplications + "/*"}
            element={
              <PrivateRoute to={Slug.login}>
                <MyApplicationsPage />
              </PrivateRoute>
            }
          />
          <Route
            path={Slug.googleApiServicesDisclosure + "/*"}
            element={<GoogleDriveDisclosure />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
